import React, { useEffect, useRef, useState } from "react";
import localData from "../../localData";
import { useGlobalContext } from "../../context";

export default function Modal({ isModalShown, setIsModalShown, dialogClassName, callback = () => {} }) {
    const { close, subscribe } = localData.svgs;
    const { sendSubscriberEmail } = useGlobalContext();

    useEffect(() => {
        const removeBodyScroll = (isModified) => {
            const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth + "px";
            const navbar = document.querySelector(".navbar");

            document.body.style.paddingRight = scrollbarWidth;
            document.body.style.overflow = "hidden";
            navbar.style.borderRight = `${scrollbarWidth} solid transparent`;
        };

        const addBodyScroll = () => {
            const navbar = document.querySelector(".navbar");

            document.body.style.paddingRight = "";
            document.body.style.overflow = "";
            navbar.style.borderRight = "";
        };
        isModalShown ? removeBodyScroll() : addBodyScroll();
    }, [isModalShown]);

    // SUBSCRIBE
    const { createAlert } = useGlobalContext();

    const form = useRef(null);

    //

    return (
        <div
            className={`modal fade ${isModalShown ? "show" : ""} `}
            id="exampleModal"
            tabIndex="-1"
            style={isModalShown ? { display: "block" } : {}}
            onClick={() => setIsModalShown(false)}
        >
            <div
                className={`modal-dialog ${dialogClassName ? dialogClassName : ""}`}
                onClick={(e) => e.stopPropagation()}
            >
                <div className="modal-content">
                    <button type="button" className="btn-close" onClick={() => setIsModalShown(false)}>
                        {close}
                    </button>
                    <form
                        className="form contact-form needs-validation"
                        noValidate
                        ref={form}
                        onSubmit={(e) => {
                            setIsModalShown(false);
                            callback();
                            sendSubscriberEmail(form, e);
                        }}
                    >
                        <div className="modal-body">
                            <div className="modal-icon">{subscribe}</div>
                            <h2 className="modal-title">Subscribe to our newsletter</h2>
                            <p className="modal-description">
                                subscribe to our newsletter to get our latest updates and discounts
                            </p>
                            <input type="text" name="to_name" defaultValue="Funmi" style={{ display: "none" }} />
                            <input
                                type="text"
                                name="text"
                                defaultValue="You have a new subscriber"
                                style={{ display: "none" }}
                            />
                            <input
                                type="email"
                                className="form-control"
                                name="from_email"
                                placeholder="Enter email address"
                                required
                            />
                            <div className="valid-feedback">looks good.</div>
                            <div className="invalid-feedback">email is required.</div>
                        </div>
                        <div className="modal-footer">
                            <button type="submit" className="btn btn-lg btn-primary">
                                <span>subscribe</span>
                            </button>
                            <button
                                type="button"
                                className="btn btn-lg btn-outline-secondary"
                                onClick={() => setIsModalShown(false)}
                            >
                                <span>maybe later</span>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}
